interface Props {
  meetingId: string | null;
  runningContext: string;
}

export function EmptyState({ meetingId, runningContext }: Props) {
  const inMeeting = runningContext === 'inMeeting';

  return (
    <div className="flex h-full flex-col items-center justify-center p-6 text-center">
      <div className="text-3xl" aria-hidden>
        📋
      </div>
      <h2 className="mt-3 text-base font-semibold">No case linked to this meeting</h2>
      {inMeeting ? (
        <>
          <p className="mt-2 max-w-sm text-sm text-gray-600">
            This Zoom meeting isn&rsquo;t tied to a Levelheaded mediation session yet. Link it
            from the case queue in the Levelheaded dashboard, then reopen the app.
          </p>
          {meetingId && (
            <p className="mt-3 text-xs text-gray-400">
              Meeting ID: <span className="font-mono">{meetingId}</span>
            </p>
          )}
        </>
      ) : (
        <p className="mt-2 max-w-sm text-sm text-gray-600">
          Open this app from a scheduled mediation meeting to see the case briefing. Outside a
          meeting, use the Levelheaded dashboard to browse the case queue.
        </p>
      )}
    </div>
  );
}
